import { useState, useEffect, createContext, useContext } from 'react';

// Création du contexte de thème
const ThemeContext = createContext({
  theme: 'light',
  toggleTheme: () => {},
});

// Hook personnalisé pour utiliser le thème
export const useTheme = () => useContext(ThemeContext);

// Fournisseur de thème à utiliser dans le composant racine
export const ThemeProvider = ({ children }) => {
  // Déterminer le thème initial (stocké localement ou préférence système)
  const [theme, setTheme] = useState(() => {
    // Vérifier d'abord si un thème est stocké localement
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) return savedTheme;
    
    // Sinon, vérifier la préférence système
    const prefersDarkMode = window.matchMedia && 
                           window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDarkMode ? 'dark' : 'light';
  });

  // Appliquer le thème au document
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Écouter les changements de préférence système
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      // Ne changer automatiquement que si l'utilisateur n'a pas explicitement choisi un thème
      if (!localStorage.getItem('theme')) {
        setTheme(e.matches ? 'dark' : 'light');
      }
    };
    
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // Fonction pour basculer entre les thèmes
  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default useTheme;